const headerCls = "c2lh1yjvlvm";
const dateHeadingCls = "c2ld16z1cia";

export { dateHeadingCls, headerCls };
import "./header.simplified.style.linaria.module.css";
//# sourceMappingURL=header.simplified.style.js.map
